import styled from "styled-components";

const SampleCloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;

export default SampleCloseButton;
